/**
 * WB-61: shown when a 402 TRIAL_LOCKED arrives without a usable sentence of
 * its own. The server normally sends one. TRIAL_LOCKED covers more than an
 * ended trial (another domain's trial, a domain owned by someone else), so the
 * fallback stays neutral.
 */
export const TRIAL_LOCKED_FALLBACK = 'This needs a paid plan or an active free trial. Upgrade to keep going.';

/**
 * The sentence to show for a 402 TRIAL_LOCKED: the server's message, unless it
 * is missing, empty or a bare code (e.g. "TRIAL_LOCKED"), in which case the
 * fallback. One source for the global toast and the inline notices.
 */
export function trialLockedMessage(raw: unknown): string {
  if (typeof raw !== 'string') return TRIAL_LOCKED_FALLBACK;
  const text = raw.trim();
  if (!text || /^[A-Z0-9_]+$/.test(text)) return TRIAL_LOCKED_FALLBACK;
  return text;
}
